(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const SLIDESHOW_SELECT = 'slideshow:select';

  function initCardGalleryThumbnails(gallery) {
    if (!(gallery instanceof HTMLElement) || gallery.dataset.cardGalleryThumbnailsInit) return;
    const row = gallery.querySelector('[data-card-gallery-thumbnails]');
    const slideshow = gallery.querySelector('slideshow-component');
    if (!row || !slideshow) return;

    gallery.dataset.cardGalleryThumbnailsInit = 'true';

    const setActiveBySlideId = (slideId) => {
      if (slideId == null) return;
      const idStr = String(slideId);
      row.querySelectorAll('.card-gallery__thumbnail').forEach((btn) => {
        const match = String(btn.dataset.slideId) === idStr;
        btn.classList.toggle('is-active', match);
        btn.setAttribute('aria-current', match ? 'true' : 'false');
      });
    };

    row.addEventListener('click', (e) => {
      const btn = e.target.closest('.card-gallery__thumbnail');
      if (!btn || !row.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      const id = btn.dataset.slideId;
      if (!id || typeof slideshow.select !== 'function') return;
      slideshow.select({ id: String(id) }, e, { animate: true });
      setActiveBySlideId(id);
      btn.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
    });

    slideshow.addEventListener(SLIDESHOW_SELECT, (ev) => {
      const id = ev.detail?.id;
      if (id != null) setActiveBySlideId(id);
    });
  }

  function scanCardGalleryThumbnails(root) {
    root.querySelectorAll('.card-gallery--has-thumbnails').forEach(initCardGalleryThumbnails);
  }

  document.addEventListener('DOMContentLoaded', () => scanCardGalleryThumbnails(document));
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) scanCardGalleryThumbnails(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
